import { render, staticRenderFns } from "./formCadastro.vue?vue&type=template&id=9fe053fc&scoped=true"
import script from "./formCadastro.vue?vue&type=script&lang=js"
export * from "./formCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe053fc",
  null
  
)

export default component.exports